import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import Main from './Main.vue'
import router from './router'
import store from './store'
import Maska from 'maska'
import convergeConfig from './config/converge'
import packageJSON from '../package.json'
const version = packageJSON.version

const payWithConvergeJS = document.createElement('script')
payWithConvergeJS.src = convergeConfig.payWithConvergeJS

const gmapsScript = document.createElement('script')
gmapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_MAPS_KEY}&libraries=places,geometry,drawing`

const wistiaScript = document.createElement('script')
wistiaScript.src = 'https://fast.wistia.com/assets/external/E-v1.js'

// We don't need wistia in local dev
if (process.env.VUE_APP_ENV !== 'local') {
  document.body.append(wistiaScript)
}

document.body.append(payWithConvergeJS, gmapsScript)

if (process.env.VUE_APP_ENV === 'local') {
  // ga and gtag to not exist in local dev
  window.ga = {}
  window.ga.getAll = () => {
    return [
      {
        get () {
          return 'testClientID'
        }
      }
    ]
  }
  window.gtag = () => { }
}

const areScriptsLoaded = () => {
  return new Promise((resolve, reject) => {
    const int = setInterval(() => {
      if (window.google) {
        clearInterval(int)
        resolve()
      }
    }, 100)
  })
}

areScriptsLoaded()
  .then(() => {
    const app = createApp(Main)
    Sentry.init({
      app,
      enabled: ['staging', 'prod'].includes(process.env.VUE_APP_ENV),
      dsn: 'https://76ccfd8ff177bf5943d547d132638f30@o4504481262206976.ingest.us.sentry.io/4507725403521024',
      release: version,
      integrations: [
        Sentry.browserTracingIntegration()
      ],
      environment: process.env.VUE_APP_ENV,
      // Performance Monitoring
      tracesSampleRate: 1.0 //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      // tracePropagationTargets: ['https://127.0.0.1', /^https:\/\/.*\.?dumpsters\.com/, /^https:\/\/.*\.?budgetdumpster\.com/]
    })
    app.use(Maska)
    app.use(store)
    app.use(router)
    app.mount('#app')
  })
